/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import { Container } from "../components/ui";
import Post from "../components/common/post";
import { Link } from "react-router-dom";
import { getPublicPosts } from "../api";
import Pagination from "components/common/Pagination";
import "../../src/assets/styles/memberPosts.scss";
import { DotLoader } from "react-spinners";

class BlogOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 0,
      total: 0,
      activePage: 1,
      posts: [],
      loading: false,
    };
  }

  isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  componentWillUnmount = () => {
    document.removeEventListener("scroll", this.trackScrolling);
  };

  componentDidMount = async () => {
    this.setState({ loading: true });
    let user = localStorage.getItem("user");
    document.addEventListener("scroll", this.trackScrolling);
    const posts = await getPublicPosts("*", 10, 0);
    this.setState({
      posts: posts ? posts.data.items : [],
      total: posts ? posts.data.total : 0,
      loading: false,
    });
  };

  handlePageChange = async (pageNumber) => {
    this.setState({ activePage: pageNumber });
    const filter = {
      authorIds: this.state.publishersSelected,
      tagIds: [],
      educationOnly: false,
      contentAvailabilityId: 2,
      publishedAt: {
        from: this.state.startDate ? this.state.startDate + " 00:00:00" : null,
        to: this.state.endDate ? this.state.endDate + " 23:59:59" : null,
      },
    };
    const posts = await getPublicPosts("*", 10, pageNumber - 1);
    this.setState(
      {
        posts: posts.data.items,
      },
      () => {
        window.scrollTo(0, 0);
      }
    );
  };

  render() {
    return this.state.loading ? (
      <div className="mainLoaderBlock">
        <DotLoader color="#36d7b7" />
        <label style={{ marginTop: 30 }}>Loading your content...</label>
      </div>
    ) : (
      <Container style={{ padding: "0px 10px" }}>
        <div
          style={{
            margin: window.screen.width > 768 ? "0% 21%" : "0% 5%",
            borderRight: "1px solid #ebebeb",
            height: window.screen.width < 768 ? "20px" : "75px",
          }}
          id={"post-wrapper"}
        ></div>
        <div
          style={{
            margin: window.screen.width > 768 ? "0% 21%" : "0% 5%",
            borderLeft: "1px solid #ebebeb",
            borderRight: "1px solid #ebebeb",
            padding: window.screen.width > 768 ? "0px 55px" : "0px 0px",
          }}
          id={"post-wrapper"}
        >
          {this.state.posts.map((post, idx) => (
            <>
              <Link
                to={`/analyst/${post.author.slug}`}
                className="card-post__author-avatar card-post__author-avatar--small"
                style={{
                  backgroundImage: `url('${post.author.avatar.small}')`,
                  zIndex: 10,
                  width: window.screen.width > 768 ? 65 : 40,
                  height: window.screen.width > 768 ? 65 : 40,
                  position: "absolute",
                  marginLeft: window.screen.width > 768 ? "-90px" : "-19px",
                }}
              ></Link>
              <Post key={idx} col={"12"} post={post} />
            </>
          ))}
          <label className="pagelabel">
            Page {this.state.activePage} of {Math.ceil(this.state.total / 7)}
          </label>
        </div>
        <div
          className="paginationDiv"
          style={{
            display: "flex",
            margin: window.screen.width > 768 ? "0% 21%" : "0% 5%",
            borderRight: "1px solid rgb(235, 235, 235)",
          }}
        >
          <Pagination
            itemClass="page-item"
            linkClass="page-link"
            activePage={this.state.activePage}
            itemsCountPerPage={7}
            totalItemsCount={this.state.total}
            pageRangeDisplayed={window.screen.width < 500 ? 1 : 3}
            onChange={this.handlePageChange.bind(this)}
            hideDisabled={true}
          />
        </div>
      </Container>
    );
  }
}

export default BlogOverview;
